import actionTypes from './constants';

/* */
const initialState = {
  dates: [],
  golfs: [],
  courses: [],
  booking: null,
  details: null,
  initial: null,
  openDates: [],
  openCourses: [],
  accessories: [],
  lockedSlot: null,
};

/* */
export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.data.SET_GOLFS_LIST:
      return {
        ...state,
        golfs: action.payload,
      };
    case actionTypes.data.SET_COURSES_LIST:
      return {
        ...state,
        courses: action.payload,
      };
    case actionTypes.data.SET_DATES_LIST:
      return {
        ...state,
        dates: action.payload,
      };
    case actionTypes.data.SET_ACCESSORIES_LIST:
      return {
        ...state,
        accessories: action.payload,
      };
    case actionTypes.data.SET_BOOKING:
      return {
        ...state,
        booking: action.payload,
      };
    case actionTypes.data.UPDATE_BOOKING:
      return {
        ...state,
        booking: {
          ...state.booking,
          ...action.payload,
        },
      };
    case actionTypes.data.DETAIL_BOOKING:
      return {
        ...state,
        details: action.payload,
      };
    case actionTypes.data.SET_LOCKED_SLOT:
      return {
        ...state,
        lockedSlot: action.payload,
      };
    default:
      return state;
  }
};
